import Form from 'antd/es/form';
import Input from 'antd/es/input';
import React from 'react';

import type { DatasetBlockConfig, PipelineBlock } from '@mai/types';

// Form flattens pagination for better UX
type DatasetFormValues = Omit<DatasetBlockConfig, 'pagination'> & {
  limit?: number;
  offset?: number;
};

interface DatasetBlockEditorProps {
  block: PipelineBlock & { type: 'dataset' };
  onConfigChange: (config: DatasetBlockConfig) => void;
}

export const DatasetBlockEditor: React.FC<DatasetBlockEditorProps> = ({
  block,
  onConfigChange,
}) => {
  const [form] = Form.useForm();

  // Initialize form with current values
  React.useEffect(() => {
    form.setFieldsValue({
      dataset_id: block.config.dataset_id || '',
    });
  }, [block.config, form]);

  const handleValuesChange = (
    _: unknown,
    allValues: Partial<DatasetFormValues>,
  ) => {
    onConfigChange({
      ...block.config,
      dataset_id: allValues.dataset_id || '',
    });
  };

  return (
    <Form
      form={form}
      layout="vertical"
      size="small"
      onValuesChange={handleValuesChange}
    >
      <Form.Item
        label="Dataset ID"
        name="dataset_id"
        rules={[{ required: true, message: 'Dataset ID is required' }]}
        help="The ID of the dataset to load"
      >
        <Input placeholder="dataset-123" />
      </Form.Item>
    </Form>
  );
};
